export default {"src":"/education/_next/static/media/prec.e4521497.svg","height":288,"width":288,"blurWidth":0,"blurHeight":0};